// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable complexity */
/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable max-statements */
/* eslint-disable max-lines-per-function */
import RwAdvisorService from '@advisor/rwSdk/AdvisorService';
import RwOrchestrateService from '@advisor/rwSdk/OrchestrateService';
import store from '@advisor/store';
import exceptionHandler from '@advisor/util/exceptionHandler';
import {PLATFORM_AREA, COMPONENT_ID, RIA_COMPONENT, RIA_ACCOUNT_STATUS, SSO_REDIRECT_URI} from '@advisor/util/constants';

export default [
  {
    // Manage: [Users, Roles]
    path: '/advisor/manage',
    name: 'Manage Access',
    component: () => import('@advisor/components/manage/ManageTabs'),
    meta: {
      breadCrumbs: {
        to: '',
        text: 'Settings',
        title: 'Manage Access',
        componentId: 10,
      },
      platformArea: PLATFORM_AREA.MANAGE_ACCESS,
      visibilityComponentId: COMPONENT_ID.MANAGE_ACCESS,
      riaComponent: RIA_COMPONENT.SETTINGS_MANAGE_ACCESS,
    },
  },
  {
    path: '/advisor/activate-advisor',
    name: 'ActivateAdvisor',
    meta: {
      unguarded: true,
    },
    component: () => import('@advisor/components/user/EmailActivation'),
    beforeEnter: async (to, from, next) => {
      // call the verification API here, if error redirect to login
      const {riaUserId} = to.query;
      const emailCode = to.query.email_code;

      try {
        const addd = await RwAdvisorService.getRiaUserFromRiaUserId({
          riaUserId,
        }).catch((error) => {
          throw error;
        });

        const email = addd?.contactInfo?.email1 || '';

        // if account status is already set redirect to login
        if (parseInt(addd.accountStatus, 10) === RIA_ACCOUNT_STATUS.ACTIVATED) {
          window.location.href = `${window.BASE_URL}?emailVerified=true&email=${email}`;

          return;
        }

        const confirmEmailResponse = await RwOrchestrateService.confirmEmail({
          riaUserId,
          emailVerificationCode: emailCode,
        });

        if (confirmEmailResponse?.error) {
          throw new Error(confirmEmailResponse.error.toString());
        }

        if (!confirmEmailResponse?.verified) {
          throw new Error(confirmEmailResponse?.verifications.toString() || 'Email not verified');
        }

        store.dispatch('user/setUserProfile', {
          account_status: addd.accountStatus,
          active: RIA_ACCOUNT_STATUS.ACTIVATED,
          email,
          first_name: addd.firstName,
          last_name: addd.lastName,
          riaUserId,
          userCrdNumber: addd.userCrdNumber,
        });
      } catch (error) {
        exceptionHandler.handleGenericException('ManageAccess.confirmEmailResponse', error);

        // redirection login url for QA env and above (SSO)
        window.location.href = `${window.BASE_URL}/${SSO_REDIRECT_URI}?emailVerified=false`;

        return;
      }

      next();
    },
  },
  {
    // Advisor: Verification
    path: '/advisor/verify-advisor',
    name: 'VerifyAdvisor',
    meta: {
      unguarded: true,
    },

    beforeEnter: async (to) => {
      // call the verification API here, if error redirect to login
      const {email} = to.query;
      const {riaUserId} = to.query;
      const emailCode = to.query.email_code;

      try {
        // returns 20[0-1] if good, 40[1-4] if bad, no specific error
        await RwOrchestrateService.verifyEmail({
          newEmail: email,
          userId: riaUserId,
          userType: 'ria_user',
          emailVerificationCode: emailCode,
          workflows: ['emailChangeExecution'],
        });

        window.location.href = `${window.BASE_URL}?emailVerified=true&email=${email}`;

        // eslint-disable-next-line no-useless-return
        return;
      } catch {
        window.location.href = `${window.BASE_URL}?emailVerified=false&email=${email}`;
      }
    },
  },
];
